import store from "../../store";

/**
 * Función para guardar en el estado al usuario que ha iniciado sesión.
 * @param { object } state El estado del módulo atual.
 * @param { object } user  Los datos del usuario que ha iniciado sesión.
 */
export function login(state, user) {
    state.user = user
    state.loggedIn = true
}

/**
 * Función para guardar en el estado a los usuarios que verá el administrador.
 * @param { object } state El estado del módulo actual.
 * @param { object } organizations Los datos de todos los usuarios.
 */
export function setOrganizations(state, organizations) {
    state.organizations = organizations;
}

/**
 * Función para guardar en el estado al usuario que ha iniciado sesión.
 * @param { object } state El estado del módulo atual.
 * @param { object } user  Los datos del uuario que ha iniciado sesión.
 */
export function setUser(state, user) {
    // Al iniciar sesión se limpia la lista de eventos.
    store.commit("event/clearOrganizationEvents");
    state.user = user
    state.loggedIn = true
}

/**
 * Función para guardar en el estado los datos de la organización con una sesión activa.
 * @param { object } state        El estado del módulo actual.
 * @param { object } dataCompany  Datos generales de una compañía. 
 */
export function setDataCompany(state, dataCompany) {
    state.dataCompany = dataCompany;
}

/**
 * Función para cerrar la sesión, eliminar los datos del estado y borrar los datos del Local storage.
 * @param {object} state El estado del módulo actual.
 */
export function logout(state) {
    state.loggedIn = false
    state.user = {}
    // Al cerrar sesión se limpia la lista de eventos.
    store.commit("event/clearOrganizationEvents");
    localStorage.removeItem('USER_TOKEN');
}

/**
 * Función que indica que se ha entrado al detalle del evento. * Importante para la barra de 
 * navegación adicional con bontón de guardar evento o regresar al formulario de nuevo evento. *
 * @param {objecto} state El estado del módulo actual.
 */
export function inEventPreview(state) {
    state.inEventPreview = true;
    state.loggedIn = false;
}

/**
 * Función en caso de dejar la vista de previsualización de un evento.
 * @param { object } state El estado del módulo actual.
 * @param { boolean } flag Bandera que indica si el usuario estaba dentro de la sesión.
 */
export function leavingEventPreview(state, flag) {
    state.inEventPreview = false;
    if(flag)
        state.loggedIn = true;
}

/**
 * Función para indicar que se entró a la ruta de detalle de evento. * Importante para la barra de 
 * navegación adicional con botón adquirir boletos. *
 * @param { object } state El estado del módulo actual.
 */
export function enteringEventDetail(state) {
    state.inEventDetail = true;
}

/**
 * Función para indicar que se está saliendo de la ruta de detalle de evento * Importante para quitar 
 * la barra de navegación adicional. *
 * @param { object } state El estado del módulo actual.
 */
export function leavingEventDetail(state) {
    state.inEventDetail = false;
}
